import { createFileRoute } from '@tanstack/react-router'
import { ReleaseNotesPage } from '@/components/pages/release-notes-page'

export const Route = createFileRoute('/release-notes')({
  component: ReleaseNotesPage,
  head: () => ({ meta: [{ title: 'Release notes — mkdn.app' }] }),
})
